import React, { useState, useEffect } from "react";
import get from "lodash/get";
import TextInput from "components/Form/TextInput";
import InputGroup from "components/Form/InputGroup";
import PreviousButton from "../PreviousButton";
import NextButton from "../NextButton";
import ProgressBar from "../ProgressBar";

const Step = ({
  onChange,
  formData,
  rewardsUser,
  onUserSignUpByStep,
  prevStep,
  nextStep,
  currentStep,
  totalSteps,
}) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});

  const onFormValidation = (_data) => {
    let result = {};
    let hasInvalidInput = false;
    const displayName = get(_data, "display_name", "");

    if (!displayName) {
      hasInvalidInput = true;
      result.display_name = !displayName
        ? "Please enter a display name."
        : "This field is required.";
    }

    setHasError(hasInvalidInput);
    setErrorMessage({ ...errorMessage, ...result });
    return hasInvalidInput;
  };

  const onBirthdayValidation = (value) => {
    let result = {};
    let hasInvalidInput = false;
    const birthday = value || get(formData, "birthday", "");
    const isDateValid =
      /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/;

    if (
      !birthday ||
      !isDateValid.test(moment(birthday).format("MM/DD/YYYY")) ||
      (isDateValid.test(moment(birthday).format("MM/DD/YYYY")) &&
        moment(birthday).isSameOrAfter(moment()))
    ) {
      hasInvalidInput = true;
      result.birthday = !birthday
        ? "Please enter a valid birthday."
        : "Invalid date range.";
    } else {
      hasInvalidInput = false;
      result.birthday = null;
    }

    setErrorMessage({ ...errorMessage, ...result });
    return hasInvalidInput;
  };

  useEffect(() => {
    if (hasError) {
      onFormValidation(formData);
      onBirthdayValidation();
    }
  }, [hasError, formData]);
  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700">
          Go {`${get(formData, "first_name", "")}`}! When's your birthday? 🎂
        </h1>
        <p className="mt-2 text-sm text-primary-700">Customize your profile.</p>
      </div>
      <div className="mt-8">
        <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        <form action="#" method="POST" className="space-y-6">
          <InputGroup
            id="displayname"
            name="displayname"
            type="text"
            label={"Display Name"}
            placeholder="Display Name"
            value={formData?.display_name}
            onChange={(value) =>
              onChange({
                ...formData,
                display_name: value,
              })
            }
            iconPosition="right"
            hasError={hasError ? get(errorMessage, "display_name", "") : null}
            required
          />
          <div>
            <TextInput
              type="date"
              label="Date of Birth"
              value={formData?.birthday}
              placeholder="mm/dd/yyyy"
              onChange={(value) => {
                setErrorMessage({ ...errorMessage, birthday: "" });
                onChange({ ...formData, birthday: value });
              }}
              hasError={
                get(errorMessage, "birthday", "")
                  ? get(errorMessage, "birthday", "")
                  : null
              }
            />
          </div>
          <div className="w-full flex justify-between">
            <PreviousButton onClick={prevStep} />
            <NextButton
              onClick={() => {
                if (!onFormValidation(formData) && !onBirthdayValidation()) {
                  onUserSignUpByStep(() => nextStep());
                }
              }}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step;
